<template>
  <div class="parent">
    <title-widge :title="title" :subTitle="subTitle"></title-widge>
    <div class="divContent">
      <div class="divLeft">
        <div class="divItem" v-for="(item, index) in leftData" :key="index">
          <img
            v-lazy="{
              src: item,
              loading: require('./../../../../../assets/wheelplanting.jpg'),
            }"
          />
        </div>
      </div>
      <div class="divRight">
        <div class="divItem" v-for="(item, index) in rightData" :key="index">
          <img
            v-lazy="{
              src: item,
              loading: require('./../../../../../assets/wheelplanting.jpg'),
            }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titleWidge from "./titleWidge";
export default {
  components: {
    titleWidge,
  },
  data() {
    return {
      leftData: [],
      rightData: [],
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    items(newValue) {
      let length = newValue.length;
      let splitIndex = Math.ceil(length / 2);
      this.leftData = newValue.slice(0, splitIndex);
      this.rightData = newValue.slice(splitIndex);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/projectAdvantageWidge.scss";
</style>
